import { callApi } from "@src/utils/api-client";
import { getFailureTypeForHttpStatus } from "@src/utils/failure-taxonomy";
import ClientLogsService from "./client-logs.service";
import { buildReferrersConfig } from "./configs";
import { runManagedRequest } from "./request-manager";

interface UpsertReferrerParams {
  user_uuid?: string;
  role?: string;
  partner_id?: string;
  referrer_team_id?: string;
  requested_callback?: boolean;
}

export async function upsertReferrer(params: UpsertReferrerParams) {
  return runManagedRequest({
    key: `referrer:${params.user_uuid ?? "unknown"}:${params.requested_callback}`,
    policy: "single-flight",
    request: async (signal) => {
      try {
        const { data, response } = await callApi(buildReferrersConfig(params, signal));

        if (!response.ok) {
          ClientLogsService.logError(
            "system",
            "referrer.service.upsertReferrer",
            "Failed to upsert referrer",
            new Error(`API responded with status ${response.status} : ${response.statusText}`),
            {
              errorType: getFailureTypeForHttpStatus(response.status),
              dependencyName: "ReferrersAPI",
              functionName: "upsertReferrer",
            },
          );
          return {
            error: (data as { message?: string } | null)?.message || "Failed to upsert referrer",
          };
        }

        return data;
      } catch (error) {
        const message = error instanceof Error ? error.message : "Failed to upsert referrer";

        ClientLogsService.logError(
          "system",
          "referrer.service.upsertReferrer",
          "Error upserting referrer",
          error instanceof Error ? error : new Error("Unknown error"),
          {
            errorType: "DependencyFailure",
            dependencyName: "ReferrersAPI",
            functionName: "upsertReferrer",
          },
        );

        return { error: message };
      }
    },
  });
}
